import { ClientFile, useDownloadFile } from "@/shared";
import { Box, Button, CircularProgress, Link, Typography } from "@mui/material";
import React from "react";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import { Colors } from "@/styles";
import { fileIcon } from "../helpers";

interface FileProps {
  file: ClientFile;
}
export const File = ({ file }: FileProps) => {
  const imageUrl = `http://${file.path}`;

  const filePath = file.file_fullname.replace("\\", "/");

  const { downloadFile, isPending } = useDownloadFile();

  const downloadImage = async (event: React.MouseEvent) => {
    try {
      event.stopPropagation();
      event.preventDefault();

      await downloadFile({ path: filePath, fileName: file.file_name });
    } catch (error) {
      console.error("Error downloading image:", error);
    }
  };

  return (
    <Box
      sx={{
        pointerEvents: isPending ? "none" : "all",
        width: 180,
        height: 190,
        borderRadius: 1,
        border: 1.2,
        borderColor: Colors.Primary,
        transition: "border-color 0.15s ease-in-out",
        cursor: "pointer",
        "&:hover": {
          borderColor: Colors.PrimaryHover,
          "& .hover-button": {
            opacity: 1,
            visibility: "visible",
          },
        },
      }}
    >
      <Link
        href={imageUrl}
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
        }}
        underline="none"
      >
        {isPending && (
          <Box
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              position: "absolute",
              zIndex: 1000,
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size="3rem" />
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 1,
            width: "100%",
            height: "100%",
            gap: 1,
          }}
        >
          <Box
            flex={3}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              backgroundColor: "#d9eaf0",
              borderRadius: 1,
              position: "relative",
            }}
          >
            {/* <>
              {!!data ? (
                <img
                  src={imageUrl}
                  alt="Description"
                  style={{ width: 100, height: 100 }}
                />
              ) : (
               
              )}
            </> */}

            {fileIcon(file.file_name)}

            <Button
              size="small"
              onClick={downloadImage}
              variant="contained"
              className="hover-button"
              sx={{
                position: "absolute",
                bottom: 5,
                opacity: 0,
                visibility: "hidden",
                transition: "opacity 0.2s ease-in-out, visibility 0.2s",
                fontSize: "0.6rem",
                padding: "2px 6px",
                minWidth: "auto",
                backgroundColor: "#43A6CB",
                "&:hover": {
                  backgroundColor: "#69b8d5",
                },
              }}
            >
              Завантажити
            </Button>
          </Box>

          <Box flex={1} sx={{ display: "flex", alignItems: "flex-end" }}>
            <Typography
              variant="body2"
              textAlign="center"
              sx={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                overflow: "hidden",
                textOverflow: "ellipsis",
                wordBreak: "break-word",
                maxWidth: "100%",
                fontSize: 13,
                fontStyle: "italic",
              }}
            >
              {file.file_name}
            </Typography>
          </Box>
        </Box>
      </Link>
    </Box>
  );
};
